<section class="schema-editor" [class.fixed-mode]="mode === 'fixed'">
  @if (mode === 'indexApp') {
    <div class="editor-block">
      <div class="block-header">
        <h3>表示項目</h3>
        <span class="block-hint">JSON を書かずに fields を編集できます</span>
      </div>

      <div class="fields-list">
        @for (field of indexAppFields.controls; track field.get('_id')?.value; let i = $index) {
          <div class="field-item">
            <div class="reorder-actions">
              <button type="button" class="order-btn" (click)="moveIndexAppFieldUp(i)" [disabled]="i === 0">▲</button>
              <button
                type="button"
                class="order-btn"
                (click)="moveIndexAppFieldDown(i)"
                [disabled]="i === indexAppFields.length - 1"
              >
                ▼
              </button>
            </div>

            <div class="field-inputs" [formGroup]="$any(field)">
              <div class="form-group mini">
                <label>項目名</label>
                <input type="text" formControlName="fieldName" placeholder="表示名" (blur)="handleBlur()" />
              </div>
              <div class="form-group mini">
                <label>変換式</label>
                <app-formula-monaco-editor
                  formControlName="formula"
                  [fieldKeys]="fieldKeys"
                ></app-formula-monaco-editor>
              </div>
              <div class="form-group mini">
                <label>固定値</label>
                <input type="text" formControlName="value" placeholder="任意" (blur)="handleBlur()" />
              </div>
            </div>

            <button type="button" class="remove-btn" (click)="removeIndexAppField(i)">×</button>
          </div>
        }
      </div>

      <div class="actions-row">
        <button type="button" class="add-btn" (click)="addIndexAppField()">+ 項目を追加</button>
      </div>
    </div>

    <div class="editor-block" [formGroup]="indexAppForm">
      <div class="block-header">
        <h3>条件と並び順</h3>
        <span class="block-hint">where / groupBy / orderBy / skip / take</span>
      </div>

      <div class="grid-fields">
        <div class="form-group span-two">
          <label>Where</label>
          <input type="text" formControlName="where" placeholder="price &gt;= 1000" (blur)="handleBlur()" />
          <span class="field-hint">単純な絞り込みはここで指定します</span>
        </div>
        <div class="form-group">
          <label>Group By</label>
          <input type="text" formControlName="groupBy" placeholder="departmentCd" (blur)="handleBlur()" />
        </div>
        <div class="form-group">
          <label>Order By</label>
          <input type="text" formControlName="orderBy" placeholder="price desc" (blur)="handleBlur()" />
          <span class="field-hint">ソートは負荷が高い場合があります</span>
        </div>
        <div class="form-group">
          <label>Skip</label>
          <input type="number" formControlName="skip" placeholder="0" (blur)="handleBlur()" />
        </div>
        <div class="form-group">
          <label>Take</label>
          <input type="number" formControlName="take" placeholder="100" (blur)="handleBlur()" />
        </div>
      </div>
    </div>

    <div class="editor-block">
      <div class="block-header">
        <h3>簡易 Filters</h3>
        <span class="block-hint">子条件を持つ複雑な filters は追加 JSON を使います</span>
      </div>

      <div class="fields-list">
        @for (filter of indexAppFilters.controls; track filter.get('_id')?.value; let i = $index) {
          <div class="field-item compact">
            <div class="field-inputs filter-inputs" [formGroup]="$any(filter)">
              <div class="form-group mini">
                <label>項目名</label>
                <input type="text" formControlName="fieldName" placeholder="price" (blur)="handleBlur()" />
              </div>
              <div class="form-group mini">
                <label>演算子</label>
                <input type="text" formControlName="expression" placeholder="==" (blur)="handleBlur()" />
              </div>
              <div class="form-group mini">
                <label>値</label>
                <input type="text" formControlName="operand" placeholder="1000" (blur)="handleBlur()" />
              </div>
            </div>

            <button type="button" class="remove-btn" (click)="removeFilter(i)">×</button>
          </div>
        }
      </div>

      <div class="actions-row">
        <button type="button" class="add-btn" (click)="addFilter()">+ Filter を追加</button>
      </div>
    </div>
  } @else {
    <div class="editor-block">
      <div class="block-header">
        <h3>View 項目</h3>
        <span class="block-hint">固定長用の `fields` を GUI で入力します</span>
      </div>

      <div class="fields-list">
        @for (field of fixedFields.controls; track field.get('_id')?.value; let i = $index) {
          <div class="field-item compact">
            <div class="reorder-actions">
              <button type="button" class="order-btn" (click)="moveFixedFieldUp(i)" [disabled]="i === 0">▲</button>
              <button
                type="button"
                class="order-btn"
                (click)="moveFixedFieldDown(i)"
                [disabled]="i === fixedFields.length - 1"
              >
                ▼
              </button>
            </div>

            <div class="field-inputs fixed-inputs" [formGroup]="$any(field)">
              <div class="form-group mini type-select">
                <label>種類</label>
                <select formControlName="kind" (blur)="handleBlur()">
                  <option value="field">項目名のみ</option>
                  <option value="formula">fieldName + formula</option>
                </select>
              </div>
              <div class="form-group mini">
                <label>項目名</label>
                <input type="text" formControlName="fieldName" placeholder="productId" (blur)="handleBlur()" />
              </div>
              <div class="form-group mini">
                <label>式</label>
                <input
                  type="text"
                  formControlName="formula"
                  placeholder="alias(productId)"
                  [disabled]="field.get('kind')?.value !== 'formula'"
                  (blur)="handleBlur()"
                />
              </div>
            </div>

            <button type="button" class="remove-btn" (click)="removeFixedField(i)">×</button>
          </div>
        }
      </div>

      <div class="actions-row">
        <button type="button" class="add-btn" (click)="addFixedField()">+ 項目を追加</button>
      </div>
    </div>
  }

  <div class="editor-block advanced-block" [formGroup]="mode === 'fixed' ? fixedForm : indexAppForm">
    <div class="block-header">
      <h3>上級設定</h3>
      <button type="button" class="toggle-btn" (click)="toggleAdvanced()">
        {{ advancedOpen ? '閉じる' : '追加 JSON を開く' }}
      </button>
    </div>

    @if (advancedOpen) {
      <div class="form-group">
        <label>追加 JSON</label>
        <textarea
          rows="8"
          formControlName="advancedJson"
          placeholder='{ "mappings": [...] }'
          (blur)="handleBlur()"
        ></textarea>
        <span class="field-hint">GUI で扱わない `mappings` や複雑な `filters` をここでマージします</span>
      </div>
    }

    @if (advancedJsonError) {
      <div class="error-text">{{ advancedJsonError }}</div>
    }
  </div>
</section>
